<script lang="ts" setup>
import { useI18n } from "vue-i18n"

defineEmits(["close"])

const { t } = useI18n({
    messages: {
        fr: {
            message: {
                header: "Comment utiliser l'outil ?",
                steps: "Suivez les étapes ci-dessous pour une analyse optimale :",
                stepA: "D'abord, cliquez sur {button} pour définir la base de <strong>l’aperçu global</strong> en sélectionnant les bâtiments ou les dossiers à analyser.",
                stepB: "Ensuite, dans le bloc <strong>suivi global :</strong>",
                step1: "Choisissez d’abord la <strong>variable</strong>",
                step2: "Puis, définissez la <strong>fréquence</strong>",
                step3: "Finalement, fixez la <strong>période</strong> de l’analyse",
                button: "Compris, merci!",
            },
        },
    },
})
</script>
<template>
    <!-- Message Component -->
    <BaseAppMessage
        closable
        class="dashboard-header-message"
        @close="$emit('close')"
    >
        <BaseAccordion value="0" unstyled>
            <BaseAccordionPanel value="0">
                <BaseAccordionHeader>
                    <h3 class="text-lg font-bold">
                        {{ t("message.header") }}
                    </h3>
                </BaseAccordionHeader>
                <BaseAccordionContent>
                    <div class="dashboard-header-message__wrapper">
                        <!-- Texte introductif des étapes -->
                        <p>{{ t("message.steps") }}</p>

                        <!-- Étapes principales (A et B) -->
                        <div class="dashboard-header-message__content-steps">
                            <!-- Étape A -->
                            <p class="dashboard-header-message__step">
                                <BaseIcon icon="fa-solid fa-circle-a" />
                                <span
                                    v-html="
                                        t('message.stepA', {
                                            button: `<span class='inline-block rounded-md border border-primary-200 bg-primary-50/50 px-3 py-2 text-[10.5px] font-bold text-primary-900'>Modifier</span>`,
                                        })
                                    "
                                ></span>
                            </p>

                            <!-- Étape B -->
                            <p class="dashboard-header-message__step">
                                <BaseIcon icon="fa-solid fa-circle-b" />
                                <span v-html="t('message.stepB')"></span>
                            </p>

                            <!-- Sous-étapes de l'étape B -->
                            <div class="dashboard-header-message__under-steps">
                                <p
                                    v-for="(step, index) in [
                                        'step1',
                                        'step2',
                                        'step3',
                                    ]"
                                    :key="index"
                                    class="dashboard-header-message__under-step"
                                >
                                    <BaseIcon
                                        :icon="`fa-light fa-circle-${index + 1}`"
                                        class="dashboard-header-message__step-icon"
                                    />
                                    <span v-html="t(`message.${step}`)"></span>
                                </p>
                            </div>
                        </div>
                        <!-- Bouton pour fermer le message -->
                        <BaseButton
                            class="dashboard-header-message__button"
                            :label="t('message.button')"
                            @click="$emit('close')"
                        />
                    </div>
                </BaseAccordionContent>
            </BaseAccordionPanel>
        </BaseAccordion>
    </BaseAppMessage>
</template>

<style scoped>
.dashboard-header-message {
    --p-message-content-padding: 2rem;
    --p-message-content-gap: 2rem;
    --p-message-info-background: var(--p-primary-100);

    .p-accordionheader {
        display: flex;
        flex-direction: row-reverse;
        align-items: center;
        justify-content: flex-end;
        gap: 1rem;
        width: 100%;
    }

    .dashboard-header-message__wrapper {
        display: flex;
        flex-direction: column;
        gap: 2rem;
        padding-top: 2rem;
    }
    .dashboard-header-message__header {
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: 0.5rem;
    }
    .dashboard-header-message__button {
        max-width: 11rem;
    }
    .dashboard-header-message__step {
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: 0.5rem;
        line-height: 2;
    }
    .dashboard-header-message__content {
        display: flex;
        flex-direction: column;
        gap: 2rem;
        & .dashboard-header-message__content-steps {
            display: flex;
            flex-direction: column;
            gap: 0.5rem;
        }
    }
    .dashboard-header-message__under-steps {
        display: flex;
        flex-direction: column;
        gap: 0.5rem;
        margin-left: 1.75rem;
        & .dashboard-header-message__under-step {
            display: flex;
            flex-direction: row;
            align-items: center;
            gap: 0.5rem;
            line-height: 2;
        }
    }
}
</style>
